var O = /* @__PURE__ */ ((C) => (C.OCCUPIED = "OCCUPIED", C.VACANT = "VACANT", C.DOWN = "DOWN", C))(O || {}), I = /* @__PURE__ */ ((C) => (C.ACTIVE = "ACTIVE", C.INACTIVE = "INACTIVE", C.COMING_SOON = "COMING_SOON", C.HOLD = "HOLD", C))(I || {});
export {
  I as ListingStatus,
  O as UnitStatus
};
//# sourceMappingURL=unit.js.map
